module.exports = __webpack_public_path__ + "media/images/icons/logout-ed874a6d8ab66c0c190914f1ce888336.svg";